"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEllipsis = exports.useUpdateEffect = exports.replaceSpaces = exports.transformHyphens = void 0;
// istanbul ignore file: doesn't hold any logic
const transformHyphens_1 = __importStar(require("./transformHyphens"));
exports.transformHyphens = transformHyphens_1.default;
Object.defineProperty(exports, "replaceSpaces", { enumerable: true, get: function () { return transformHyphens_1.replaceSpaces; } });
const useUpdateEffect_1 = require("./useUpdateEffect");
Object.defineProperty(exports, "useUpdateEffect", { enumerable: true, get: function () { return useUpdateEffect_1.useUpdateEffect; } });
const createEllipsis_1 = __importDefault(require("./createEllipsis"));
exports.createEllipsis = createEllipsis_1.default;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdXRpbHMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSwrQ0FBK0M7QUFDL0MsdUVBQXFFO0FBSTVELDJCQUpGLDBCQUFnQixDQUlFO0FBQUUsOEZBSkEsZ0NBQWEsT0FJQTtBQUh4Qyx1REFBb0Q7QUFHVixnR0FIakMsaUNBQWUsT0FHaUM7QUFGekQsc0VBQThDO0FBRWEseUJBRnBELHdCQUFjLENBRW9EIn0=